import { BaseModel } from './base.model';

export class Config extends BaseModel {
  id?: string;
  name?: string;
  type?: number;
  value?: string;
}